import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../../../models/link';
import ImageHolder from '../../ImageHolder';

const IMAGE_TYPE = {
  big: "big",
  small: "small",
  none: "none"
};

class LinkView extends Component {
  static propTypes = {
    link: PropTypes.instanceOf(Link).isRequired
  };

  get imageType() {
    const { link : { images } } = this.props;
    if (images.isEmpty()) {
      return IMAGE_TYPE.none;
    }

    const image = images.first();

    if (Number(image.get('width')) > 350 && Number(image.get('height')) > 140) {
        return IMAGE_TYPE.big;
    } else if (Number(image.get('width')) > 61 && Number(image.get('height')) > 61) {
        return IMAGE_TYPE.small;
    }
    return IMAGE_TYPE.none;
  }

  renderImage() {
    const { link : { images } } = this.props;

    if (this.imageType === IMAGE_TYPE.big) {
      return (
        <div className="wrap_thumb">
          <ImageHolder image={images.first()} />
        </div>
      );
    } else if (this.imageType === IMAGE_TYPE.small) {
      return (
        <div className="wrap_thumb">
          <ImageHolder image={images.first()} style={{ position: 'absolute', top:0, left:0, width: 125, height:125 }} />
        </div>
      );
    }
    return null;
  }

  render() {
    const { link } = this.props;

    return (<div className={`card_default card_scrab${this.imageType === IMAGE_TYPE.small ? " card_scrab2" : "" }`}>
        <a href={link.requestedUrl} className="link_card" target="_blank">
          {this.renderImage()}
          <div className="info_cont">
            <strong className="tit_card">{link.title}</strong>
            {
              (link.description && link.description !== "") ? (
                  <p className="desc_card">{link.description}</p>
                ) : null
            }
            <span className="txt_url">{link.host}</span>
          </div>
        </a>
      </div>
    );
  }
}

export default LinkView;



// WEBPACK FOOTER //
// ./src/components/PostBox/media/LinkView.js